"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchGlassIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const SearchGlassIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ width: 25, height: 25, viewBox: "0 0 25 25", fill: "none" }, props, { children: [(0, jsx_runtime_1.jsx)("path", { d: "M.896 1h23.843v24H.896V1z", fill: "none" }), (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14.48 12.941a6.002 6.002 0 00-9.134-7.72 6 6 0 007.72 9.135l.75.75a1 1 0 00.258.966l4.603 4.603a1 1 0 001.415 0l.707-.707a1 1 0 000-1.414l-4.604-4.604a1 1 0 00-.966-.259l-.75-.75zm-2.063-.648A4 4 0 106.76 6.636a4 4 0 005.657 5.657z", fill: color !== null && color !== void 0 ? color : theme.colors.grey30 })] })));
};
exports.SearchGlassIcon = SearchGlassIcon;
//# sourceMappingURL=search_glass_icon.js.map